import React from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import FAQS from "../../components/FAQS/FAQS";
import Footer from "../../components/Footer";

const FAQSPage = () => {

	return (
		<div>
			<Helmet>
				<title>Help Desk</title>
			</Helmet>
			<Header />
			<FAQS />
			<Footer />
		</div>
	);
};

export default FAQSPage;